module.exports = __webpack_public_path__ + "static/archivoschile.97c3b8aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/archivoschile.jpg
// module id = 456
// module chunks = 202660965941462